































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { convertComplexidadeEnumToString } from '@/types/enum/ComplexidadeEnum'

@Component

export default class ComponentBackofficeProcedimento extends Vue {
  @Prop({ required: true, default: false }) showProcedimentoOnly: boolean

  get lateralidadeEmProcedimento() {
    const { template } = this.getBackofficeGlobalStore
    return template && template.formulario && template.formulario.lateralidade && template.formulario.lateralidade.lateralidadeEmProcedimento
  }

  get coberturaVigente() {
    // eslint-disable-next-line
    return this.getItensProcedimentos.some((p: any) => p.hasOwnProperty('coberturaVigente'))
  }

  get anestesiaDoHospital() {
    const anestesiaLabel = {
      Sim: 'Sim',
      Nao: 'Não',
      NaoAplica: 'Não se aplica',
      Outros: 'Outros',
    }
    return this.getBackofficeGlobalStore.solicitacao.anestesiaDoHospital ? anestesiaLabel[this.getBackofficeGlobalStore.solicitacao.anestesiaDoHospital as string] : '-'
  }

  get anestesista() {
    return this.getBackofficeGlobalStore.solicitacao.anestesista
  }

  get reoperationInfo() {
    if (typeof this.getBackofficeGlobalStore.solicitacao.reoperacao === 'boolean') {
      return this.getBackofficeGlobalStore.solicitacao.reoperacao ? 'Sim' : 'Não'
    }

    return '-'
  }

  get pacemakerInfo() {
    if (typeof this.getBackofficeGlobalStore.solicitacao.marcapasso === 'boolean') {
      return this.getBackofficeGlobalStore.solicitacao.marcapasso ? 'Sim' : 'Não'
    }

    return '-'
  }

  get covidTestInfo() {
    if (typeof this.getBackofficeGlobalStore.solicitacao.testeCovid === 'boolean') {
      return this.getBackofficeGlobalStore.solicitacao.testeCovid ? 'Sim' : 'Não'
    }

    return '-'
  }

  get pacienteB24PositivoInfo() {
    if (typeof this.getBackofficeGlobalStore.solicitacao.pacienteB24Positivo === 'boolean') {
      return this.getBackofficeGlobalStore.solicitacao.pacienteB24Positivo ? 'Sim' : 'Não'
    }

    return '-'
  }


  get pacienteEhTestemunhaDeJeovaInfo() {
    if (typeof this.getBackofficeGlobalStore.solicitacao.pacienteEhTestemunhaDeJeova === 'boolean') {
      return this.getBackofficeGlobalStore.solicitacao.pacienteEhTestemunhaDeJeova ? 'Sim' : 'Não'
    }

    return '-'
  }

  get pacienteEDiabeticoInfo() {
    if (typeof this.getBackofficeGlobalStore.solicitacao.pacienteEhDiabetico === 'boolean') {
      return this.getBackofficeGlobalStore.solicitacao.pacienteEhDiabetico ? 'Sim' : 'Não'
    }

    return '-'
  }

  get temPrecaucoes() {
    return (this.getBackofficeGlobalStore.solicitacao.precaucoes && this.getBackofficeGlobalStore.solicitacao.precaucoes.key !== 'Nao')
      ? 'Sim'
      : 'Não'
  }

  formattedPrivateProcedureField(isPrivate) {
    if (typeof isPrivate === 'boolean') {
      return isPrivate ? 'Sim' : 'Não'
    }

    return '-'
  }

  getTecnica(item: any) {
    if (item.tecnicaDoProcedimento && item.tecnicaDoProcedimento.descricao) return item.tecnicaDoProcedimento.descricao

    if (this.getBackofficeGlobalStore.solicitacao.protocoloDeCirurgia && this.getBackofficeGlobalStore.solicitacao.protocoloDeCirurgia.tecnicaDeCirurgia) {
      return this.getBackofficeGlobalStore.solicitacao.protocoloDeCirurgia.tecnicaDeCirurgia.nome
    }

    return '-'
  }

  displayExamesIntraOperatorios(exame: any) {
    const equipeHospital = exame !== null && exame.key && exame.key.toLowerCase() === 'ultrassonografiaintraoperatoria' && exame.equipeDoHospital !== null
      ? ` - Precisa da equipe do hospital: ${exame.equipeDoHospital ? 'SIM' : 'NÃO'} `
      : ''

    const outros = exame !== null && exame.key && exame.key.toLowerCase() === 'outros' && exame.outrosEspecificar !== null
      ? ` - ${!['', null, undefined].includes(exame.outrosEspecificar) ? exame.outrosEspecificar : '-'} `
      : ''

    const hospitalOuParticular = exame !== null && exame.key && exame.hospitalOuParticular
      ? ` - Origem do serviço: ${!['', null, undefined].includes(exame.hospitalOuParticular) ? exame.hospitalOuParticular : '-'} `
      : ''

    const particularLocal = exame !== null && exame.key && exame.particularLocal
      ? ` - Local de prestação do serviço: ${!['', null, undefined].includes(exame.particularLocal) ? exame.particularLocal : '-'} `
      : ''

    return `${exame ? exame.display : ''} ${equipeHospital}${outros}${hospitalOuParticular}${particularLocal}`
  }

  precaucoes(item) {
    if (item.precaucoes && item.precaucoes.key === 'Sim') return item.especificarPrecaucoes
    if (item.precaucoes && item.precaucoes.key === 'Outro') return item.especificarPrecaucoes
    if (item.precaucoes && item.precaucoes.key === 'PrecaucaoRespiratoriaPorGoticulas') return 'Precaução respiratória por gotículas'
    if (item.precaucoes && item.precaucoes.key === 'PrecaucaoRespiratoriaPorAerosol') return 'Precaução respiratória por aerosol'
    if (item.precaucoes && item.precaucoes.key === 'PrecaucaoPorContatoERespiratoriaPorAerosol') return 'Precaução por contato respiratório por aerosol'
    if (item.precaucoes && item.precaucoes.key === 'PrecaucaoEspecial') return 'Precaução especial'
    return 'Não'
  }

  get headers() {
    const headers = this.lateralidadeEmProcedimento
      ? [
        { text: 'Procedimento', class: 'table-headers-email', align: 'left', value: 'procedimento', sortable: false },
        { text: 'Qtd solicitada', class: 'table-headers-email', align: 'center', value: 'quantidade', sortable: false },
        { text: 'Lateralidade', class: 'table-headers-email', align: 'center', value: 'lateralidade', sortable: false },
      ]
      : [
        { text: 'Procedimento', class: 'table-headers-email', align: 'left', value: 'procedimento', sortable: false },
        { text: 'Qtd solicitada', class: 'table-headers-email', align: 'center', value: 'quantidade', sortable: false },
      ]

    if (this.coberturaVigente) {
      headers.push({ text: 'Cobertura vigente', class: 'table-headers-email', align: 'center', value: 'coberturaVigente', sortable: false })
    }

    headers.push({ text: 'Técnica da cirurgia', class: 'table-headers-email', align: 'center', value: 'tecnicaDaCirurgia.descricao', sortable: false })

    if (this.qtdeAutorizada) {
      headers.push({ text: 'Qtd autorizada', class: 'table-headers-email', align: 'center', value: 'quantidadeAutorizada', sortable: false })
    }

    headers.push({ text: 'Particular', class: 'table-headers-email', align: 'center', value: 'particular', sortable: false })

    return headers
  }

  get doctorsSurgeryTeam() {
    return this.getBackofficeGlobalStore.solicitacao.equipeCirurgica
  }

  temQuantidadeAutorizada(procedimentos: any) {
    const truthyValues: boolean[] = []
    procedimentos.forEach((procedimento: any) => {
      // eslint-disable-next-line
      truthyValues.push('quantidadeAutorizada' in procedimento)
    })
    return truthyValues.some((e: boolean) => e === true)
  }

  get qtdeAutorizada() {
    return this.temQuantidadeAutorizada(this.getItensProcedimentos)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get tipoAnestesia() {
    return this.getBackofficeGlobalStore.solicitacao.tipoAnestesiaTemp || []
  }

  get getItensProcedimentos() {
    const a = this.getBackofficeGlobalStore.solicitacao.procedimentosAssociados ? this.getBackofficeGlobalStore.solicitacao.procedimentosAssociados : []
    return [this.getBackofficeGlobalStore.solicitacao.procedimento, ...a]
  }

  get convertComplexidadeEnumToString() {
    return convertComplexidadeEnumToString
  }

  campoHabilitado(prop: string) {
    if (this.getBackofficeGlobalStore.template.formulario) {
      const response = this.getBackofficeGlobalStore.template.formulario[prop]
      if (response) return response.habilitado
    }

    return false
  }

  opcaoHabilitado(prop1: string, prop2: string) {
    if (this.getBackofficeGlobalStore.template.formulario) {
      const response = this.getBackofficeGlobalStore.template.formulario[prop1]
        && this.getBackofficeGlobalStore.template.formulario[prop1].campos
        && this.getBackofficeGlobalStore.template.formulario[prop1].campos[prop2]
      return response
    }

    return false
  }

  dadosGestacionaisHabilitado() {
    return !!(this.getBackofficeGlobalStore.solicitacao.procedimento
      && this.getBackofficeGlobalStore.solicitacao.procedimento.habilitaCamposGestacionais)
      || (this.getBackofficeGlobalStore.solicitacao.procedimentosAssociados
        && this.getBackofficeGlobalStore.solicitacao.procedimentosAssociados.some(procedimento => procedimento.habilitaCamposGestacionais))
  }
}
